module.exports = __webpack_public_path__ + "img/icon_login.8463065e.png";